import { Component, ViewChild, ChangeDetectorRef} from "@angular/core";
import { Filter, HttpService } from "../../services";
import { TreeComponent } from "angular-tree-component";
import { TreeUtil } from "../../util/tree";
import { AgentUtility } from "../../util/agent.utility";
import { Router } from "@angular/router";
import { PagerService } from "../../services/pager.service";
import { StringUtility } from "../../util/string.utility";
import { AgentsService } from "../../services/agents.service";
import { ResponseApi } from "../../services/response/response";

enum TypeView {
    TableView,
    TreeView
}

@Component({
    moduleId: module.id,
    selector: 'agent-tree',
    templateUrl: 'agent-tree.component.html',
    styleUrls: ['agent-tree.component.css'],
    providers: [AgentsService, PagerService]
})
export class AgentTreeComponent {
    @ViewChild('tree',{static: false})
    private tree: TreeComponent;
    checkLoad: boolean = false;
    lastIndex: any;
    filter: Filter = new Filter();
    nodes: any = [];
    pager: any = {};
    pageSize: number = 25;
    filterValues: Filter = new Filter();
    agentsTable: any = [];
    showLoadScreen: boolean = false;
    _typeView = TypeView;
    typeView: number;
    totalItems: any;
    treeOnlyEnabledFilter: boolean = true;
    options = {
        isExpandedField: "isExpanded"
    };

    constructor(private agentService: AgentsService, private router: Router, private pagerService: PagerService, private changeRef: ChangeDetectorRef) {
        this.agentService.onStart = () => this.showLoadScreen = true;
        this.agentService.onEnd = () => this.showLoadScreen = false;
    }

    all(event) {
        if (event.eventName == "onUpdateData") {
        }
        
        
    }

    checkLast(i) {
        if (this.checkLoad)
            return;
        this.checkLoad = true;
        this.showLoadScreen = !this.checkLoad;
        
    }

    getLast(data) {
        // if(data[data.length - 1] != null){
        //     var first = data[data.length - 1];
        //     for(var i = 0; i < first.length)
        // };
    }

    ngOnInit() {
        let agentId = this.getUser().Id;
        this.filterValues.Id = agentId;
        this.filterValues.page = 1;
        this.filter.Id = agentId;
        this.filter.page = null;
        this.filter.onlyEnabled = true;
        this.treeOnlyEnabledFilter = true;
        // для IE и Edge по умолчанию включаем табличное представление
        this.typeView = TypeView.TableView;
        this.agentService.getAgentTreeAll(this.filter)
            .subscribe((res: ResponseApi) => {
                let data = res.data;
                this.nodes.push(data[0]);
                this.tree.treeModel.update();
                this.tree.treeModel.expandAll();
                this.expanTreeToAgent();
            });
        this.agentService.getAgentTreeAll(this.filterValues).subscribe((res: ResponseApi) => {
            let data = res;
            this.agentsTable = data.data;
            this.totalItems = data.countAll;
            this.setPage(1);
        });
    }

    isIEBrowser(): boolean {
        let ua: string = window.navigator.userAgent;
        let msie = ua.indexOf('MSIE '),
            trident = ua.indexOf('Trident/');
        //edge = ua.indexOf('Edge/');
        return msie > 0 || trident > 0;// || edge > 0;
    }

    // onEvent = function (event) {
    //     //
    //     if (event.node.children.length > 0)
    //         return false;
    //     if (event.node.isSearch)
    //         return false;
    //     let currNode = TreeUtil.getSubMenuItem(this.nodes, event.node.id);
    //     let myContractId = this.getUser().Id;
    //     let myContractLeaderId = this.getUser().ContractLeaderId;
    //     // если нажимаем на себя, возвращаем всех подчиненных
    //     if (currNode.Id == myContractId) {
    //         this.toggleSubordinates(currNode);
    //         return;
    //     }
    //     this.httpService.getAgentsTreeByClientLeaderId(myContractLeaderId).subscribe(data => {
    //         let agents = data;
    //
    //         this.httpService.getAgent(this.getUser().Id).subscribe((data) => {
    //             agents.push(data);
    //             if (agents) {
    //                 for (let i = 0; i < agents.length; i++) {
    //                     if (currNode.Id == agents[i].Id) {
    //                         let childAgent = agents.filter((agent) => {
    //                             return agent.ContractLeaderId == agents[i].Id;
    //                         });
    //                         //
    //                         // if (childAgent[0].Id == myContractLeaderId) {
    //                         //     //this.toggleSubordinates(currNode, myContractLeaderId);
    //                         //
    //                         // }
    //
    //                         childAgent[0].hasChildren = true;
    //                         childAgent[0].children = [];
    //                         childAgent[0].withLink = currNode.Id == myContractLeaderId ? true : false;
    //                         //childAgent[0].isParent = true;
    //                         currNode.children = childAgent;
    //                         this.nodes = [...this.nodes, {}];
    //                         this.nodes.splice(-1, 1);
    //
    //                         return false;
    //                     }
    //                 }
    //                 this.toggleSubordinates(currNode);
    //             }
    //         });
    //
    //     });
    //     return;
    // };

    // toggleSubordinates(currNode, contractLeaderId = undefined) {
    //     this.toggleLoadScreen();
    //     let filter = new Filter();
    //     filter.ContractLeaderId = contractLeaderId != undefined ? contractLeaderId : currNode.Id;
    //     filter.limit = "all";
    //     let agents = this.httpService.getAgentsByFilter(filter).subscribe((data) => {
    //         if (data.agents !== undefined && data.agents.length > 0) {
    //             for (let i = 0; i < data.agents.length; i++) {
    //                 data.agents[i].hasChildren = true;
    //                 data.agents[i].children = [];
    //                 data.agents[i].withLink = true;
    //             }
    //             currNode.children = data.agents;
    //         } else {
    //             currNode.children = [];
    //             currNode.hasChildren = false;
    //             currNode.isParent = false;
    //             currNode.withLink = true;
    //         }
    //         // Фикс рефреша дерева
    //         this.nodes = [...this.nodes, {}];
    //         this.nodes.splice(-1, 1);
    //         this.toggleLoadScreen();
    //     });
    // }


    onClickFilter(value, tree, onlyEnabled) {
        if(this.treeOnlyEnabledFilter != onlyEnabled){
            this.onFilter(value);            
        }
        else
        {
            let clearFilter = false;
            if ((value == "" || !value) && !onlyEnabled){
                tree.treeModel.clearFilter();
                clearFilter = true;
            }
            tree.treeModel.filterNodes((node) => {
                let condition = false;
                try{
                    if(value == "" || !value){
                        condition = node.data.IsActive;
                    }
                    else{
                        condition = node.displayField.toLowerCase().indexOf(value.toLowerCase()) != -1;
                        condition = onlyEnabled? condition && node.data.IsActive : condition;
                    }
                }
                catch(ex){
                    condition = false;
                }
                node.data.marked = clearFilter? false : condition;
                return  clearFilter? clearFilter : condition;
            }, true);
        }
    }


    onFilter(value) {
        this.agentService.getAgentTreeAll(this.filter)
            .subscribe((res: ResponseApi) => {
                this.treeOnlyEnabledFilter = this.filter.onlyEnabled;
                this.nodes = [];
                let data = res.data;
                this.nodes.push(data[0]);
                this.tree.treeModel.update();
                this.changeRef.detectChanges();            
                this.onClickFilter(value, this.tree, this.filter.onlyEnabled)
                
                if(this.filter.onlyEnabled == false)
                    this.expanTreeToAgent();
        });
    }    

    setLinkView(node, boolLink: boolean, currId: number) {
        if (node != null && node.length > 0) {
            let withLink = boolLink;
            if (node[0].Id == currId)
                withLink = true;
            for (let i = 0; i < node.length; i++) {
                node[i].withLink = withLink ? true : false;
                if (node[i].children && node[i].children.length > 0)
                    this.setLinkView(node[i].children, withLink, currId);
            }
        }
    }

    getUser(): any {
        return AgentUtility.getUser();
    }
    
    setAgentLK(id) {
        this.agentService.getAgent(id).subscribe((data: ResponseApi) => {
            this.agentService.getV_Agent(id).subscribe((v_agent: ResponseApi) => {
                let agent = data.data;
                agent['v_agent'] = v_agent.data;
                AgentUtility.setOtherUserInfo(agent);
                this.router.navigateByUrl('/');
            });
        });

    }

    debug(obj) {
        
    }

    getDateIsView(StatusId) {
        var notRedStatuses = [3, 10, 8];
        if (notRedStatuses.indexOf(StatusId) == -1) {
            return true;
        } else {
            return false;
        }
    }

    getPagerView(): boolean {
        //
        return this.pager.pages && this.pager.pages.length && this.pager.totalItems > this.pageSize;
    }

    setPage(page: number, needRequest: boolean = false) {
        this.pager = this.pagerService.getPager(this.totalItems, page, this.pageSize);
        if (page < 1 || page > this.pager.totalPages) {
            return;
        }
        if (needRequest) {
            this.filterValues.page = page;
            this.agentService.getAgentTreeAll(this.filterValues).subscribe((res: ResponseApi) => {
                let data = res;
                this.agentsTable = data.data;
                this.totalItems = data.countAll;
                this.pager = this.pagerService.getPager(this.totalItems, page, this.pageSize);
            });
        }
    }

    filterTable() {
        this.filterValues.page = 1;
        this.agentService.getAgentTreeAll(this.filterValues).subscribe((res) => {
            let data = res;
            this.agentsTable = data.data;
            this.totalItems = data.countAll;
            this.setPage(1);
        });
    }

    clear() {
        this.filterValues.fio = "";
        this.filter.onlyEnabled = true;
        this.setPage(1, true);
    }

    filterPhoneView(str) {
        return StringUtility.PhoneMask(str);
    }

    getColorRow(status) {
        var RedStatuses = [3, 10, 8];
        if (RedStatuses.indexOf(status) == -1) {
            return 'black';
        } else {
            return 'red';
        }
    }

    expanTreeToAgent(){
        let clearFilter = false;
        let agentId = this.getUser().Id;
        this.tree.treeModel.doForAll((node) => {
            let nodeAgentId = node.data.Id;
            if(nodeAgentId == agentId){
                node.collapse();
            }
        });
    }
}